export default __webpack_public_path__ + "static/media/33.f95d5a35.jpeg";